import React from 'react';

const HiddenInput = props => (
  <input
    type="hidden"
    name={`${props.groupName}[${props.name}]`}
    value={props.value || ''} />
);

HiddenInput.defaultProps = {
  groupName: 'parameters',
  name     : '',
};

export default HiddenInput;
